export default __webpack_public_path__ + "media/images/marker-7dbd3b2dafcfbe5184af93e5952ee3da.svg";